export default{
    msg:'',
    editar:{},
    lista:'',
    
}